<template>
  <Card>
    <LocalDataTable :columns="columns" :ajax-link="ajaxLink"></LocalDataTable>
  </Card>
</template>

<script>
import Card from "@/components/forms/Card";
import LocalDataTable from "@/components/LocalDataTable";
import {mapActions} from "vuex";
export default {
  name: "BankTransactionsList",
  components: {LocalDataTable, Card},
  data()
  {
    return{
      columns : [
        {title : 'تاریخ ایجاد'},
        {title : 'نام کاربر'},
        {title : 'مبلغ(تومان)'},
        {title : 'رسید بانکی'},
        {title : 'آخرین تغییر'},
        {title : 'وضعیت'},
      ],
      ajaxLink : 'admin/bankTransactions/List'
    }
  },
  mounted()
  {
    this.setPageTitle('تراکنش های بانکی');
    this.setShowHead(true);
    this.setPageLoading(false);
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
  }

}
</script>

<style scoped>

</style>